export { NODE_RECAPTCHA_SITE_KEY_NAME, executeCaptcha } from '../src/recaptcha';
